import { Button, Icon } from '@platform/components';
import { ReactNode } from 'react';

type PaginationBarProps = {
  numPages: number;
  currentPage: number;

  onPageSelect: (page: number) => void;
};

export const PaginationBar = (props: PaginationBarProps) => {
  const { numPages, currentPage, onPageSelect } = { ...props };

  const buttonsToRender = [];

  // display up to 3 numbers, then ellipses, then current page if > 3
  for (let i = 1; i <= numPages; i++) {
    if (i === 5) {
      buttonsToRender.push(<PaginationPip content={'...'} key='ellipses-end' />);
    }
    if (i <= 3) {
      buttonsToRender.push(
        <PaginationPip
          onPageSelect={() => onPageSelect(i)}
          content={i}
          bold={i === currentPage}
          key={i}
        />,
      );
    } else if (i === currentPage) {
      buttonsToRender.push(
        <PaginationPip onPageSelect={() => onPageSelect(i)} content={i} bold={true} key={i} />,
      );
    } else if (i >= numPages - 2) {
      buttonsToRender.push(
        <PaginationPip
          onPageSelect={() => onPageSelect(i)}
          content={i}
          bold={i === currentPage}
          key={i}
        />,
      );
    }
    if (currentPage > 4 && currentPage < numPages - 4 && i === currentPage + 1) {
      buttonsToRender.push(<PaginationPip content={'...'} key='ellipses-start' />);
    }
  }

  const isNextEnabled = currentPage < numPages;
  const isPreviousEnabled = currentPage > 1;

  const onClickNext = () => {
    if (isNextEnabled) {
      onPageSelect(currentPage + 1);
    }
  };

  const onClickPrevious = () => {
    if (isPreviousEnabled) {
      onPageSelect(currentPage - 1);
    }
  };

  return (
    <div className='flex flex-row justify-between w-full pt-5 mt-10 border-t border-border-secondary items-center h-[60px]'>
      <Button
        variant='tertiary-gray'
        size='md'
        onPress={onClickPrevious}
        isDisabled={!isPreviousEnabled}
      >
        <Icon type='arrow-left' size='16' />
        Previous
      </Button>
      <div className='flex flex-row gap-3'>{buttonsToRender}</div>
      <Button variant='tertiary-gray' size='md' onPress={onClickNext} isDisabled={!isNextEnabled}>
        Next
        <Icon type='arrow-right' size='16' />
      </Button>
    </div>
  );
};

type PaginationPipProps = {
  content: ReactNode;
  bold?: boolean;
  onPageSelect?: () => void;
};
export const PaginationPip = (props: PaginationPipProps) => {
  const { content, bold, onPageSelect } = { ...props };
  return (
    <div
      onClick={onPageSelect}
      className={`text-sm w-4 h-4 ${bold ? 'font-semibold' : ''} ${
        onPageSelect ? 'cursor-pointer' : ''
      }`}
    >
      {content}
    </div>
  );
};
